import axios, {
  AxiosError,
  AxiosInstance,
  AxiosResponse,
  CreateAxiosDefaults,
  InternalAxiosRequestConfig,
} from 'axios';

export interface RequestBaseOptions extends CreateAxiosDefaults {}

/**
 * 请求
 */
export class RequestBase {
  axios: AxiosInstance;

  get: AxiosInstance['get'];
  post: AxiosInstance['post'];
  put: AxiosInstance['put'];
  delete: AxiosInstance['delete'];
  patch: AxiosInstance['patch'];
  options: AxiosInstance['options'];

  constructor(options: RequestBaseOptions = {}) {
    this.axios = axios.create(options);
    this.axios.interceptors.request.use(
      this.requestInterceptorFulfilled.bind(this),
    );
    this.axios.interceptors.response.use(
      this.responseInterceptorFulfilled.bind(this),
      this.responseInterceptorRejected.bind(this),
    );

    this.get = this.axios.get;
    this.post = this.axios.post;
    this.put = this.axios.put;
    this.delete = this.axios.delete;
    this.patch = this.axios.patch;
    this.options = this.axios.options;
  }

  requestInterceptorFulfilled(config: InternalAxiosRequestConfig) {
    return config;
  }
  responseInterceptorFulfilled(response: AxiosResponse) {
    return response;
  }
  responseInterceptorRejected(error: AxiosError) {
    return Promise.reject(error);
  }
}
